module.exports = __webpack_public_path__ + "static/media/foto1.d77fbcd2.jpg";